export const iconFontAwesomeTextformattingSubscript = (
	<i className="fa-solid fa-subscript"></i>
);
